import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaWhatsapp, FaYoutube } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="footer-section">
            <div className="container">
                <div className="row g-3 text-start rows-footer">
                    {/* Contact */}
                    <div className="col-12 col-md-6 col-lg-6 col-xl-8 mb-4">
                        <h5 className="text-uppercase text-white fa-18 mb-3">Contact</h5>
                        <ul className="list-unstyled fa-18">
                            <li>रेडक्रॉस भवन, सिव्हिल हॉस्पिटल रोड, जळगाव.</li>
                            <li>0257-2226233, 2236255, 2235855 9422436566, 9422536566</li>
                            <li>ircs_jal@yahoo.in, ircs1953@gmail.com</li>
                        </ul>
                    </div>

                    {/* About Us */}
                    <div className="col-12 col-md-6 col-lg-4 col-xl-2 mb-4">
                        <h5 className="text-uppercase text-white fa-18 mb-3">About Us</h5>
                        <p className="fa-18">
                            Indian Red Cross Society (IRCS) is established in 1920 under the Indian Red Cross Society Act and incorporated under Parliament Act XV of 1920.
                        </p>
                    </div>


                    {/* Follow Us */}
                    <div className="col-12 col-md-6 col-lg-2 col-xl-2 mb-4">
                        <h5 className="text-uppercase text-white fa-18 mb-3">Follow Us</h5>
                        <div className="row g-2">
                            <div className="col">
                                <a href="https://www.facebook.com/redcrossjalgaon" target="_blank" className="footer-icon shadow-none rounded-1">
                                    <FaFacebookF />
                                </a>
                            </div>
                            <div className="col">
                                <a href="https://api.whatsapp.com/send/?phone=9422436566&text&type=phone_number&app_absent=0" target="_blank" className="footer-icon shadow-none rounded-1">
                                    <FaWhatsapp />
                                </a>
                            </div>
                            <div className="col">
                                <a href="#" target="_blank" className="footer-icon shadow-none rounded-1">
                                    <FaTwitter />
                                </a>
                            </div>
                            <div className="col">
                                <a href="https://www.instagram.com/ircs_jalgaon/?igsh=MWVicG53dzhjZ3J3ZQ%3D%3D#" target="_blank" className="footer-icon shadow-none rounded-1">
                                    <FaInstagram />
                                </a>
                            </div>
                            <div className="col">
                                <a href="https://www.youtube.com/@indianredcrosssocietyjalga8046" target="_blank" className="footer-icon shadow-none rounded-1">
                                    <FaYoutube />
                                </a>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Bottom Section */}
                <div style={{ borderTop: "1px solid #444", fontSize: "14px" }}></div>
                <div className="row pt-3 mt-3">
                    <div className="col-12 col-md-6">
                        <div className="fa-16">
                            Copyright © {new Date().getFullYear()} <a className="text-whtie" href="#">Indian Redcross Society</a> - Powered by <a className="text-whtie" href="#">AppDroid Be Online</a>
                        </div>
                    </div>
                    <div className="col-12 col-md-6" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'end' }}>
                        <ul className="list-unstyled" style={{ display: 'flex', gap: "10px", fontSize: "18px" }}>
                            <li><a href="#" style={{ color: "#ddd", textDecoration: "none" }}>Terms & Conditions</a></li>
                            <li><a href="#" style={{ color: "#ddd", textDecoration: "none" }}>Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
